const health = [
  {
    path: '/health-records',
    name: 'health-records',
    component: () => import(/* webpackChunkName: "healthrecords" */ '@/pages/health-records/index.vue'),
    meta: {
      login: true,
      titleBar: {
        title: '健康监测'
        // hasMenu: true
      }
    }
  },
  {
    path: '/add-edit',
    name: 'add-edit',
    component: () => import(/* webpackChunkName: "addedit" */ '@/pages/health-records/add-edit.vue'),
    meta: {
      login: true,
      titleBar: {
        title: '新增档案'
        // hasMenu: true
      }
    }
  },
  {
    path: '/health-self-test',
    name: 'health-self-test',
    component: () => import(/* webpackChunkName: "health-self-test" */ '@/pages/health-self-test/health-self-test.vue'),
    meta: {
      login: false,
      titleBar: {
        title: '健康测评',
        hasMenu: true
      }
    }
  },
  {
    path: '/test-introduce',
    name: 'test-introduce',
    component: () => import(/* webpackChunkName: "test-introduce" */ '@/pages/health-self-test/test-introduce.vue'),
    meta: {
      login: true,
      titleBar: {
        title: '健康测评',
        hasMenu: true
      }
    }
  },
  {
    path: '/test-result',
    name: 'test-result',
    component: () => import(/* webpackChunkName: "test-result" */ '@/pages/health-self-test/test-result.vue'),
    meta: {
      login: true,
      titleBar: {
        title: '测试结果',
        hasMenu: true
      }
    }
  },
  {
    path: '/test-finish',
    name: 'test-finish',
    component: () => import(/* webpackChunkName: "test-finish" */ '@/pages/health-self-test/test-finish.vue'),
    meta: {
      login: true,
      titleBar: {
        title: '测评报告',
        hasMenu: true
      }
    }
  },
  {
    path: '/test-record',
    name: 'test-record',
    component: () => import(/* webpackChunkName: "test-record" */ '@/pages/health-self-test/test-record.vue'),
    meta: {
      login: true,
      titleBar: {
        title: '自测记录',
        hasMenu: true
      }
    }
  },
  {
    path: '/answer-page',
    name: 'answer-page',
    component: () => import(/* webpackChunkName: "answer-page" */ '@/pages/health-self-test/answer-page.vue'),
    meta: {
      titleBar: {
        title: '健康测评',
        hasMenu: true
      }
    }
  }
]

export default health
